export enum CustomInputTypes {
  TextInput = 'TextInput',
  SelectInput = 'SelectInput',
  DateInput = 'DateInput',
  SwitchInput = 'SwitchInput',
}
